import { useActor } from '@xstate/react';
import { useEffect } from 'react';
import { RazorPayRedirectModal } from 'src/app/payments/shared/RazorPay/RazorPayRedirectModal';
import { confirmRazorPay } from 'src/app/payments/shared/RazorPay/confirm';
import useRetryPaymentService from '../xstate/useRetryPaymentService';

export const RazorPayAuthModalContainer = () => {
  const retryPaymentService = useRetryPaymentService();
  const [state, send] = useActor(retryPaymentService);
  const isRazorPayAuthRequired = state.matches('razorPayAuth');
  const paymentAuthUrl = state.matches('razorPayAuth') ? state.context.paymentAuthUrl : '';

  useEffect(() => {
    async function listenToMessage() {
      const razorpayPostVerificationInfo = await confirmRazorPay();
      if (razorpayPostVerificationInfo) {
        send({
          type: 'CONFIRM_AFTER_RAZORPAY_AUTH',
          razorPayAuthResponse: razorpayPostVerificationInfo.message,
          razorPayAuthStatus: razorpayPostVerificationInfo.status,
        });
      } else {
        send({
          type: 'CANCEL_RAZORPAY_AUTH',
        });
      }
    }
    if (isRazorPayAuthRequired) {
      listenToMessage();
    }
  }, [isRazorPayAuthRequired, send, state]);

  const closeModalWithCancelAction = () => {
    send({
      type: 'CANCEL_RAZORPAY_AUTH',
    });
  };

  return (
    <RazorPayRedirectModal
      open={!!paymentAuthUrl && paymentAuthUrl.length > 0}
      paymentAuthUrl={paymentAuthUrl}
      closeModalWithCancelAction={closeModalWithCancelAction}
      data-testId="razorpay-auth-modal"
    />
  );
};
